import {API_SERVERLESS, postFetch} from '~commonApi';

export function apiBackOfficeTemplateActive({templateId}) {
    return postFetch(`${API_SERVERLESS}/backOffice/v3/templateActivate`, true, {templateId});
}
